import React from 'react'
import OpStageManager, { OpStageManager as OpStageManagerNamed } from '../../../../components/ProductionFlow/OpStageManager'

interface FashionStageManagerProps {
  opId: number
  isFashion?: boolean
}

const StageManagerComponent = OpStageManager || OpStageManagerNamed

export const FashionStageManager: React.FC<FashionStageManagerProps> = ({ opId, isFashion = true }) => {
  if (!StageManagerComponent) return null
  return <StageManagerComponent opId={opId} isFashion={isFashion} />
}

export default FashionStageManager
